<template>

    <m-edit1/>

    <m-reset-email-password-1 v-bind='{...{"image":"https:\/\/api.pamenarvillage.ir\/storage\/icons\/voFHj4IPLpnnzeENXr9YDNfcZPf29X5GdJIteOz5.png"},...{}}' :style='""' class="" ></m-reset-email-password-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mResetEmailPassword1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/ResetEmailPassword/ResetEmailPassword1';

export default {
    name: 'HomeView',
    components: {mEdit1, mResetEmailPassword1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
